import React, { memo } from "react"
import { FlexContainer } from "../../styled/layout.styled"
import { H3 } from "../../styled/typography.styled"
import styled from "@emotion/styled"

const StyledH3 = styled(H3)`
  font-weight: 600;
  font-style: normal;
  display: inline-block;
  position: relative;
  margin: 0 0 30px;
  z-index: 1;
  padding-bottom: 7px;
  ::before {
    display: block;
    position: absolute;
    content: "";
    background-color: #353535;
    width: 100%;
    height: 2px;
    bottom: 0;
  }
  ::after {
    display: block;
    position: absolute;
    content: "";
    background-color: #007ced;
    width: 30px;
    height: 2px;
    bottom: 0;
  }
`

const SectionTopic = ({ topic }) => {
  return (
    <FlexContainer flexWrap="wrap">
      <StyledH3>{topic}</StyledH3>
    </FlexContainer>
  )
}

export default memo(SectionTopic)
